import {reduxForm} from 'redux-form';
import config from 'config';
import FromComponent from './StreamEditForm';
import {streamAction} from '../../../../actions/stream/customStream';
import {STREAM_EVENT_PAST} from '../../../../api/stream/CustomStreamEvent';
import {validateRedux, validateAsyncRedux} from '../../../../utilites/validate';
import {goBack} from 'react-router-redux/lib/actions';
let CRUDActions = streamAction;

const validate = (data, form) => {
  const validationParams = {
    title: {
      presence: {
        message: '^Stream Name is missing'
      }
    },
    startDate: {
      presence: {
        message: '^Please set the start time'
      }
    },
    description: {
      presenceContent: {
        message: '^Description is missing'
      }
    },
    countries: {
      presence: {
        message: '^Countries is missing'
      }
    }
  };

  const validationLinks = {
    m3u8: {
      presence: {
        message: '^Please add a main stream link'
      }
    },
    m3u8_backup: {
      presence: {
        message: '^Please add a backup stream link'
      }
    }
  };

  if (data.is_live) {
    form.fields.forEach(field => form.touch(field));
    return validateRedux(data, { ...validationLinks, ...validationParams });
  }

  return validateRedux(data, validationParams);
};

const asyncValidate = (data) => validateAsyncRedux(data, {
  logo: {
    presence: {message: '^Please upload an image'},
    minImageSizeAsync: config.streamCrop
  }
});

export default reduxForm(
  {
    form: 'stream_edit_form',
    fields: [
      'title',
      'm3u8',
      'm3u8_backup',
      'is_live',
      'trigger_push_notifications',
      'push_notifications_triggered',
      'vip_only',
      'startDate',
      'logo',
      'endDate',
      'description',
      'countries'
    ],
    returnRejectedSubmitPromise: true,
    asyncBlurFields: ['logo'],
    model: {},
    asyncValidate,
    validate
  },
  ({customStream: {model = {}}, customStream: {filter: streamType}}) => ({
    model,
    disabled: streamType === STREAM_EVENT_PAST,
    isPublished: model && model.isPublished && model.published,
    initialValues: model
      ? {
        title: model.title,
        m3u8: model.m3u8,
        m3u8_backup: model.m3u8_backup,
        is_live: model.is_live,
        trigger_push_notifications: model.id ? false : true,
        push_notifications_triggered: model.push_notifications_triggered,
        vip_only: model.vip_only,
        startDate: model.startDate,
        logo: model.logo,
        endDate: model.endDate,
        description: model.description,
        countries: model.countries
      }
      : {}
  }),
  dispatch => ({
    save: async (item, data) => await dispatch(CRUDActions.save(item, data)),
    publish: async (item, data) => await dispatch(CRUDActions.publish(item, data)),
    onClose: () => {
      dispatch(goBack());
      dispatch(CRUDActions.onCloseEditForm());
    }
  })
)(FromComponent);



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamEditForm/index.js